<template>
  <div>
    <breadcrumbs :home="tank.name + ': Proof'"/>

    <v-card flat>
      <v-form v-model="valid" ref="form" :disabled="!edit">
        <v-container class="pt-6 px-6 purtrak-scrollable" fluid>

          <v-row dense no-gutters>
            <v-col cols="6" sm="4" lg="3">
              <date-picker v-model="transaction.date" @change="refresh"/>
            </v-col>
            <v-col class="text-caption ml-5 mt-3 grey--text">
              {{tankContents}}
              <template v-if="init || transactionId!=undefined"/>
              <span v-else-if="emptyTank" class="warning--text ml-10">Cannot proof empty tank</span>
              <span v-else-if="tank.contents.alcoholType!=='Spirit'" class="warning--text ml-10">Cannot proof a tank not holding spirits</span>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6" sm="3" lg="2">
              <alcohol-input label="Strength" strength-only :strength.sync="transaction.strength" :disabled="!edit"/>
            </v-col>
          </v-row>
          <v-row dense >
            <v-col cols="12">
              <v-text-field label="Comments" v-model="transaction.comments" outlined dense counter="255" :rules="[fieldRules.maxLength(255)]"/>
            </v-col>
          </v-row>
          <v-row >
            <v-col cols="12" class="font-italic">
              Note that any subsequent transaction involving this tank will result in the proofing being voided
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-divider/>
      <v-card-actions class="px-6">
        <template v-if="transactionId && company.permissions.includes('production.write')">
          <v-switch v-if="transaction.date > company.excisePeriodEnd || edit" :disabled="dirty"
                    v-model="edit" label="Edit" hide-details class="mt-0"/>
          <div v-else class="grey--text">Cannot edit since excise filed to period end {{company.excisePeriodEnd | formatDate}}</div>
        </template>
        <v-spacer/>
        <v-btn :plain="edit" color="primary" @click="cancel">{{edit?'Cancel':'Done'}}</v-btn>
        <v-btn v-if="edit" color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
  </div>

</template>

<script>
import {format} from 'date-fns'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'EquipmentTanksProof',
  mixins: [confirmLeave],
	props: {
    tankId: {type:String,required:false},
    transactionId: {type:String, required:false}
	},
	data() {
		return {
      init: true,
      edit: false,
      tank: {name:'',contents:{}},
      valid:true,
      saving:false,
      transaction: {tankId:this.tankId, date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'), strength: 0, comments: ''},
      dirty: false
		}
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    tankContents() {
      return this.tank.contents.volume ? this.tank.contents.alcoholName : '(empty)';
    },
    emptyTank() {
      return this.transactionId ? false : this.tank.id && this.tank.contents.volume === 0;
    }
  },
  watch: {
    transaction: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
	async created() {
    if (this.transactionId) {
      const results = await this.$apiCall(`query EquipmentTanksProof($id:ID!) {
                                                tankProof(id:$id) {
                                                  tankId,date,strength,comments
                                                }
                                              }`,
                                          {id:this.transactionId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.transaction = results.data.tankProof;
      this.transaction.id = this.transactionId;
    }
    await this.refresh();
    if (!this.transactionId)
      this.edit = true;
    this.$nextTick(() => this.dirty = false);
    this.init = false;
  },

	methods: {
    async refresh() {
      const results = await this.$apiCall(`query EquipmentTanksProof($id:ID!,$asof:DateTime!) {
                                              tank(id:$id) {
                                                id,name,
                                                contents(date:$asof){volume,alcoholName,alcoholType,proofed,lot}
                                              }
                                            }`,
                                          {id:this.transaction ? this.transaction.tankId : this.tankId,asof:this.transaction.date});
      if (!results.error) {
        this.tank = results.data.tank;
        this.$nextTick(() => this.$refs.form.validate());
      }
    },
    cancel() {
      this.$router.back();
    },
		async save() {
      if (this.valid) {
        this.saving = true;
        const results = await this.$apiCall(`mutation EquipmentTanksProof($input: TankProofInput!) {
                                                tankProofCreate(input:$input) {id}
                                              }`,
                                            {input:this.transaction});
        this.saving = false;
        if (!results.error) {
          this.dirty = false;
          this.$router.back();
          this.$store.commit('setError', {type:'success',message:`${this.transactionId?'Updated':'Created'} tank proof transaction for ${this.tank.name}`});
        }
      }
		}
	}
}
</script>